import React from "react";
import "./whyus.css";
import whyusimage from "../../images/cover1.jpg";
export default function aboutus() {
  return (
    <div className="kingwhy">
      <div className="sky">
        <img className="aboutusleft" src={whyusimage} alt="" />
        <div className="leftright">
          <div className="left11">
            <h1>Why Us</h1>
            <li>We are competent. reliable and efficient</li>
            <p>
              <li>We offer free maintainance for a period of one year.</li>
            </p>
            <li>We have a 24 hour full customer support</li>
            <p>
              <li>
                We offer upto 10 percent discount for subsequent trackers
                purchased
              </li>
            </p>
            <li>
              Our trackers are of high quality and are accreditted by IEEE
              international standards
            </li>
          </div>
          <div className="right1">
            <div>
              <button className="searchbutt">Search...</button>
              <div className="searchicon"></div>
            </div>
            <div className="line1"></div>
            <div className="linkslinks">Links</div>
            <li className="hommee">Home</li>
          </div>
        </div>
      </div>
      <div className="middle1">
        <h2>We have the best fleet management System</h2>
        <p>
          Our Fleet Management solution is a unique offer as it sets the
          benchmark for companies that require a high standard of vehicle and
          operational information. This solution provides one with unlimited
          fleet basic web access, giving you full vehicle control and operations
          assets management. The systems enable you to manage your fleet
          remotely by using your mobile phone, Ipad, tablets, or PC and desktop.
        </p>
        <p>
          LAFEMA SYSTEMS Fleet Management solution is mainly suitable for fleet
          owners who require to simply track their vehicles, know their
          locations, and from time-to-time access to reports on routes traveled,
          where the vehicle stopped, duration of the stop, and many other
          simples but effective features essential in the transport industry.
          Our fleet management solution is tailored to enable effective and
          efficient management of fleets of long-distance operations including
          Trailers and Haulers, Buses, Vans, Matatus, Taxis, Corporates, and
          many others.
        </p>

        <h2>Our vehicle tracking Features</h2>
      </div>
      <div className="down1">
        <div className="mwanzo">
          <li>History Reports and Vehicle Route Playback</li>
          <li>Engine cut off directly from Mobile Phone or Computer</li>
          <li>SOS panic button</li>
          <li>Idle Time Reports</li>
          <li>The exact location of a stolen vehicle</li>
          <li>Speed Reports</li>
          <li>The setting of Custom Alerts such as vehicle Speeding Alerts</li>
          <li>Internal Power Backup up to 3 days</li>
          <li>Fuel Consumption Reports</li>
          <li>Brake PSI Reports</li>
          <li>Driver Identification</li>
        </div>
        <div className="katikati8">
          <li>Real-time Location Reports</li>
          <li>Track vehicle Via SMS and GPRS from Mobile Phone or Computer</li>
          <li>InstantPower Disconnection Alert and Backup.</li>
          <li>Tracking by time interval</li>
          <li>Built-in motion sensor for power saving</li>
          <li>Alert when a vehicle enters or exits GPS blind area</li>
          <li>Alert when the vehicle is turned on</li>
          <li>Sound recording</li>
          <li>Digital Input for Engine Control</li>
        </div>
        <div className="mwisho">
          <li>Mileage Reports</li>
          <li>Driver Identification</li>
          <li>Engine Cut by SMS</li>
          <li>Speeding alert</li>
          <li>Low battery alert</li>
          <li>Geo-fencing control</li>
          <li>Fuel Level Sensors</li>
          <li>Over speed Detection Reports</li>
          <li>Engine Temperature</li>
          <li>Coolant Temperature</li>
        </div>
      </div>
    </div>
  );
}
